import "./creditLengthChangeData.css";
import React from 'react';

const CreditLengthChangeData = (props) => {

    const lengthChangeData = props.creditLengthChanges.map(creditLengthChange => (
        <>
            <tr key={creditLengthChange.key}>
                    <td>
                        {creditLengthChange.date}
                    </td>
                    <td>
                        {creditLengthChange.value}
                    </td>
                    <td>
                        <button className="actionButtonTable" value={creditLengthChange.key} onClick={props.handleDeleteCreditLengthChange}>Usuń</button>
                    </td>
            </tr>
        </>
    ))

    const lenghtChangeDataStructure = (
        <table className="lengthChangeTable">
                <tbody>
                    <tr>
                        <th width="50%">Data</th>
                        <th>Wartość</th>
                        <th>Akcja</th>
                    </tr>
                    {lengthChangeData}
                </tbody>
        </table> 
    )

    return ( 
        <>
            <div className="tableRow">
                {props.creditLengthChanges.length === 0 ? '' : lenghtChangeDataStructure}
            </div>  
        </>
    );
}
 
export default CreditLengthChangeData;
